export default function require( id: string ) {
	switch ( id ) {
		default: throw new Error( `Failed to load ${id}` );
		case 'jquery': return window.jQuery;
	}
}

window.require = require as any;
